import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import moment from 'moment'
import { StoreExt } from '@utils/reactExt'

import { logs } from '@services/api'
import { filter } from 'lodash'

export class logsStore extends StoreExt {
    @observable analyzedList = {}
    @observable analyzeBy = null
    @observable loading = false
    @observable list = []
    @observable filters = {}
    @observable errors = {}

    @action
    analyzeData = () => {
        let analyzedList = {}
        this.list.forEach(({ _source: item }) => {
            let value = null
            if (this.analyzeBy in item) {
                value =
                    this.analyzeBy === 'date' ? moment(item[this.analyzeBy]).format('DD/MM/YYYY') : item[this.analyzeBy]
            } else if (this.analyzeBy === 'keywords' && ('keywords' in item.attributes || 'name' in item.attributes)) {
                value = 'keywords' in item.attributes ? item.attributes.keywords : item.attributes.name
            } else if (this.analyzeBy in item.attributes) {
                value = item.attributes[this.analyzeBy]
            }
            if (value) {
                const key = `${value}__${item.subType}`
                analyzedList[key] = {
                    ...item,
                    value,
                    count: key in analyzedList ? analyzedList[key].count + 1 : 1
                }
            }
        })
        runInAction(() => {
            this.analyzedList = { ...analyzedList }
        })
    }

    @action
    setAnalyzeBy = value => {
        this.analyzeBy = value
    }

    @action
    getLogsList = async () => {
        this.loading = true
        if (this.checkFilters()) {
            logs.getList({ ...this.filters })
                .then(res => {
                    runInAction(() => {
                        this.list = res.data.results.hits
                        this.analyzedList = {}
                        this.analyzeBy = null
                        this.errors = {}
                    })
                })
                .catch(e => {
                    runInAction(() => {
                        this.list = []
                        this.analyzedList = {}
                        this.analyzeBy = null
                        this.errors = { serverError: 'קיימת שגיאה בשרת' }
                    })
                })
        }
        this.loading = false
    }

    checkFilters = () => {
        let errors = {}
        if (!('type' in this.filters)) errors['type'] = 'עליך לבחור סוג דוח'
        runInAction(() => {
            this.errors = errors
        })
        return Object.keys(errors).length === 0
    }

    @action
    addFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = newFilters
        })
    }

    @action
    resetFilters = (filters = []) => {
        if (filters.length > 0) {
            const newFilters = { ...this.filters }
            filters.forEach(filter => filter in newFilters && delete newFilters[filter])
            runInAction(() => {
                this.filters = newFilters
                this.analyzedList = {}
                this.analyzeBy = null
            })
        } else {
            this.filters = {}
            this.analyzedList = {}
            this.analyzeBy = null
        }
    }

    @action
    resetList = () => {
        this.list = []
        this.analyzedList = {}
        this.analyzeBy = null
    }
}

export default remotedev(new logsStore())
